/* eslint-disable indent */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchRecentSignUps } from "../../Redux/Actions";
import { Constants } from "../Common/Constants";
import titleCase from "../Common/Functions/titleCase";
import PageHeader from "../Common/PageHeader";
import { RoutesUrl } from "../Common/RoutesUrl";
import TableList from "../Common/UiModel/TableList";

const RecentSignups = () => {
  const { recentSignUpList } = useSelector((store) => store.RecentSignUps);
  const dispatch = useDispatch();
  useEffect(function () {
    dispatch(fetchRecentSignUps());
  }, []);

  // Columns for User list
  const columns = [
    {
      name: Constants.id,
      width: "6%",
      cell: (_row, i) => i + 1,
    },
    {
      name: Constants.email,
      selector: (row) => (
        <Link to={`${RoutesUrl.users}/${row?._id}`}>
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={row?.userData?.email}
          >
            {row?.email}
          </span>
        </Link>
      ),
    },
    {
      name: Constants.name,
      selector: (row) => {
        const { userName, name, firstName, lastName } = row || {};
        const fullName = firstName && lastName ? `${firstName} ${lastName}` : null;
        return fullName ?? name ?? userName ?? Constants.na;
      }
    },
    {
      name: Constants.gender,
      selector: (row) => titleCase(row?.gender),
    },
    {
      name: Constants.number,
      selector: (row) => (row?.mobile ? `+91 ${row?.mobile}` : Constants.na),
    },
    {
      name: Constants.dateOfJoining,
      selector: (row) => (row?.createdAt ? new Date(row.createdAt).toDateString() : Constants.na),
    },
  ];

  return (
    <div className="mb-4">
      <div className="mt-3">
        <PageHeader pagetitle={Constants.recentSignups} />
      </div>
      <TableList
        columns={columns}
        data={recentSignUpList}
        defaultSortFieldId
        highlightOnHover
      />
    </div>
  );
};

export default RecentSignups;
